import { render } from "./WorkerTagTable.vue?vue&type=template&id=1b6abe5c"
import script from "./WorkerTagTable.vue?vue&type=script&lang=js"
export * from "./WorkerTagTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__